import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { assetConditionSchema as schema } from '../../_validationSchema';
import { assetConditionAction as actions } from '../../_action/assetCondition.action';
import { assetCondition_model as model } from '../../_model';
import { assetConditionConstants as constants } from '../../_constants';

import { useSelector } from 'react-redux';

const AssetCondition = (props) => {
  const { t } = props;

  const header = { name: 'AssetCondition', icon: 'cubes' };
  const reducer = useSelector((state) => state.assetConditionOperation);

  const filenameXML = 'asset-condition';
  const menuCode = 'M_ASSET_CON';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Description' },
  ];
  let useService = () => {
    return [schema, actions, model, constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);

  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(AssetCondition);
